/* Copyright(c) 2019 APSS Media Pvt. Ltd.
 *  All Rights Reserved
 */
import React from "react";
import Footer from "../layouts/footer";
import PublisherNavigation from "../layouts/publisherNavPage";
import { MDBRow, MDBCol } from "mdbreact";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logoutUser } from "../login/authentication";
import { withRouter } from "react-router-dom";
// import fs from "fs";  //Nilesh-4240-Removing console warnings
import { saveAs } from "file-saver";
import { Table, Checkbox } from "antd"; // Nilesh-4726 Add checkbox
import { css } from "emotion";
import "./loader.css";
//import { LeadReviewLoader } from "../loaders/LeadReviewLoader"; //Sandeep-task-3499-removed old loader
import "./publisherDeliverLead.css";
import { FaArrowAltCircleLeft } from "react-icons/fa";
import { fetch_custom as fetch } from "../../configration/fetch_default_headers"; //sonali-task-3945-added default header
import { json } from "body-parser";
// import { methods } from "underscore";

// const queryString = require("query-string");  //Nilesh-4240-Removing console warnings
const xlsx = require("xlsx");
const Swal = require("sweetalert2");
var dateTime = require("node-datetime"); //Somnath Task-3403, date time to get date time in specified format
// const alertAudio = new Audio("C/Users/a/Downloads"); //5761-not used
const tableCSS = css({
  backgroundColor: "white",
  borderStyle: "bold",
  "& thead  > tr": {
    backgroundImage: "linear-gradient(to right,#28166f,#007cc3)!important",
    color: "white",
    fontSize: "14px",
    fontWeight: "500",
  },
  "& thead > tr >th": {
    border: "1px solid black",
    height: "20%",
    color: "white",
  },
});

var leadLength;
var leadFileExt;
class PublisherDeliverLead extends React.Component {
  constructor() {
    super();
    this.state = {
      campID: "",
      parentCampID: "",
      reallocationID: "",
      selectedFile: null,
      filesData: [],
      fields: {},
      leadDetails: [],
      leadDetailsData: [],
      getExt: [],
      leadDetailsData1: [],
      leadDetailsDataTest: [],
      errors: {},
      fileerrors: {},
      formaterrors: {},
      inputClass: "disabled",
      campaignLevelSwitch: "",
      DI_QA_Switch: "",
      msg: " ", //sandeep-task-3119-added code to store message
      columnSearch: [], //shivani-task-3204-added array for search functionality.
      key1: "lead", //shivani-task-3204-passed key in url .
      tableSearchText: "", //shivani-task-3204-declared variable for search .
      pageSize1: 100, //shivani-task-3204-declare variable for pagination records .
      selectedLead: " ", //shivani-task-3204-declared variable for filter the selected  status .
      leadResponseDetails: [], //shivani-task-3204-declared array for filter functionality .
      leadDetailsResponse: [], //shivani-task-3204-declared array for filter functionality .
      allDataArray: [], //shivani-task-3204-declared array for filter functionality
      rejectlead: 0, //shivani-task-3204-declared variable to display the reject lead count .
      loading1: false, //shivani-task-3204-declared variable to display loader .
      loaderLead: "", //Sandeep-task-3499-added code for loader
      headerErrors: {}, //Priyanka-4635-Added array to display error messages
      rejectedHeaders: "", //Priyanka-4635-Declared array to display rejected headers
      missingHeaders: "", //Priyanka-4635-Declared array to display missing headers
      duplicateHeaders: "", //Chaitanya-4719-Declared array to display missing headers
      domainChecked: false, // Nilesh-4726-Store domainCheck value
      isDomainCheckedboxVisible: true,
      domainChecking: "",
      btnDisable: "btn add-button",

      showMandatoryAssetModal: false, //5705  Modal visibility flag
      showMandatoryAssetButton: false, // 5705  Button visibility flag
      isModalOpen: false, // 5705 Optional flag for modal
      mandatoryTimer: "00:00:00", // 5705 Timer for showing end time (example)
      validData: [], //5705 Store valid assets data
      multitouchConfigData: [], //5705 Store multitouch config data
      isMultiTouch: false, //5705 Flag to check if it is multi-touch mode
       campID: null, //5705 Campaign ID
      mappingFields:[], //Anshul-5813: added to store mapping fields
      showHelpModal: false, //Nilesh-6004-Added to show help modal
      searchText: "", //Nilesh-6004-Added to store search text
      
      
    };

    this.submitDeliverLead = this.submitDeliverLead.bind(this);
    this.handleChangeFileDeliverLead =
    this.handleChangeFileDeliverLead.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.downloadAuditReport = this.downloadAuditReport.bind(this);
    this.displayCampaignSpecification =
    this.displayCampaignSpecification.bind(this);
    //shivani-task 3204- bind below all functions for pagination, search funtionality and filter out the data as user will select the status .
    this.handleChangePageSize1 = this.handleChangePageSize1.bind(this);
    this.handleChangeSearch = this.handleChangeSearch.bind(this);
    this.selectLead = this.selectLead.bind(this);
    this.filterResponseLead = this.filterResponseLead.bind(this);
    this.viewVoiceLogs = this.viewVoiceLogs.bind(this); //sonali-3945-added this for VAPT
    this.updateLeadCount = this.updateLeadCount.bind(this); // Nilesh-4757-Bind the function
    this.handleButtonClick = this.handleButtonClick.bind(this);//5705-Kiran -Bind this Function
    this.handleCloseModal = this.handleCloseModal.bind(this);//5705-Kiran 
    // Sandeep-task-3499-removed old loader for loading issue
    //  this.loadingRef = React.createRef(); // shows the Loader
    //  this.closeLoadingRef = React.createRef(); // hides the Loader
  }
  // Kiran Dhainje Bug 5772 Prod Issue-PC-Lead Upload-Mandatory Assets page showing blank
decodeIfEncoded = (val) => {
          if (typeof val !== "string") return val;
 
          try {
            return unescape(val);
          } catch (e) {
            return val;
          }
        };
  //sonali-3945-added this for VAPT
  viewVoiceLogs(e) {
    e.preventDefault();
    this.props.history.push("/voiceLogsUpload", {
      campID: this.props.location.state.campID,
      parentCampID: this.props.location.state.parentCampID,
      reallocationID: this.props.location.state.reallocationID,
    }); //sonali-task-3945-replace query params
  }

  //5736 Kiran Dhainje PAT Issue-PC-Lead Upload-Mandatory Asset page showing wrong count
  formatDateIST(date) {
    const options = {
      weekday: 'short',   // Thu
      year: 'numeric',    // 2025
      month: 'short',     // Jan
      day: '2-digit',     // 30
      hour: '2-digit',    // 07
      minute: '2-digit',  // 22
      second: '2-digit',  // 01
      hour12: true,       // AM/PM format
      timeZone: 'Asia/Kolkata', // IST
    };
    const formattedDate = date.toLocaleString('en-US', options);
    return `${formattedDate} (IST)`;  // Add IST manually
  }




  /**
   * @author Narendra Phadke
   * @param  Description handle the login authentication
   * @return Description return All details of authentication
   */
  componentDidMount() {
    //Sonali-3945-VAPT
    if (this.props.location.state !== undefined) {
      const { parentCampID, campID, reallocationID } =
        this.props.location.state;
      this.setState({ reallocationID, campID, parentCampID });
    }
    // var campID = this.props.location.state.campID;  //Nilesh-4240-Removing console warnings
    var parentCampID = this.props.location.state.parentCampID;
    var reallocationID = this.props.location.state.reallocationID;
    var key2 = this.state.key1;

    this.setState({ parentCampID, reallocationID, key2: key2 });

    // const { isAuthenticated, user } = this.props.auth;  //Nilesh-4240-Removing console warnings

    if (!this.props.auth.isAuthenticated) {
      this.props.history.push("/userLogin");
    }
    this.setState({ campID: this.props.location.state.campID });
    fetch(
      "publisher/getDeliveryFileExtension?campID=" +
        this.props.location.state.campID
    )
      .then((res) => res.json())
      .then((getExt) => {
        this.setState({ getExt: getExt[0].leadDeliveryOption });
      })
      .catch(function (err) {
        console.log(err);
      });

    let data = {
      //pID:user.id,//sonali-3945-removing pID from the following call
      campID: this.props.location.state.campID,
    };

    fetch("/diQARole/getFlag", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((getFlag) => {
        this.setState({
          campaignLevelSwitch: getFlag[0].campaignLevelSwitch,
          DI_QA_Switch: getFlag[1].DI_QA_Switch,
        });
      })

      .catch(function (err) {
        console.log(err);
      });


        
  /**
   * @author Kiran Dhainje
   * @param 5705 - PC/PNC-Lead Upload-Display Mandatory Assets
   * @return Description return All details of file
   */
    const campID = this.state.campID || this.props.location.state?.campID;
    if (!campID) return console.log("Campaign ID is missing");

    // Fetch asset data when the component mounts
    try {
      fetch("/publisher/getAssetValidation", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ campID }),
      })
      .then((response) => response.json())
      .then((data) => {
        const assets = data.assets || [];
        const isMultiTouch = data.isMultiTouch || false;
        const newlyAddedAsset = data.newlyAddedAsset; // 5765 Kiran Dhainje Prod Issue-PC-Mandatory Asset not showing newly added assets fixed Newly added asset from the backend 


        const allFilesSelected = assets.every((a) => a.allowFlag === "Yes");
        const hasMandatory = assets.some((a) => a.allowFlag !== "Yes");
        const validAssets = assets.filter((a) => a.allowFlag === "Yes");

        const allowed = assets.find((a) => a.allowedDate);
        const expiryTime = allowed?.allowedDate
          ? new Date(allowed.allowedDate).getTime() + 12 * 60 * 60 * 1000 // Add 12 hours to allowedDate
          : null;

        const now = Date.now();
        const shouldStartTimer = hasMandatory && expiryTime && now <= expiryTime;
        const hideButtonAfterTimer = now > expiryTime;

        // Format permittedTime and permissionEndTime in IST
        const permittedTime = new Date(allowed?.allowedDate || Date.now()); // Use current time if no allowedDate
        const permissionEndTime = new Date(permittedTime.getTime() + 12 * 60 * 60 * 1000); // Add 12 hours

        {/*Kiran Dhainje 5736 PAT Issue-PC-Lead Upload-Mandatory Asset page showing wrong count */}
        const formattedPermittedTime = this.formatDateIST(permittedTime);
        const formattedPermissionEndTime = this.formatDateIST(permissionEndTime);

        this.setState(
          {
            isModalOpen: true,
            hideButtonAfterTimer,
            isMultiTouch,
            assetIdCheck: data.assetIdCheck,
            multitouchConfigData: isMultiTouch ? assets : [],
            validData: assets,
            showMandatoryAssetButton: !allFilesSelected && validAssets.length > 0,
            mandatoryTimerExpiry: expiryTime,
            permittedTime: formattedPermittedTime, // Store permitted time (in IST) kiran Dhainje 5736
            permissionEndTime: formattedPermissionEndTime, // Store permission end time (in IST) Kiran Dhainje 5736
            newlyAddedAsset: newlyAddedAsset || null, // 5765 Kiran Dhainje Save the newly added asset
            

          },
          () => {
            if (shouldStartTimer && !allFilesSelected) {
              this.startCountdown(expiryTime); // Start the countdown timer if required
            }
          }
        );
      })

          
      .catch((error) => {
        console.error("Error loading mandatory assets:", error);
      });
    } catch (error) {
      console.error("Error loading mandatory assets:", error);

      
    }
  }
//5705 Kiran PC/PNC-Lead Upload-Display Mandatory Assets
handleButtonClick() {
    this.setState({
      showMandatoryAssetModal: true, // Open the form
    });
  }



  //5705 **Method for closing the modal**
  handleCloseModal() {
    this.setState({
      showMandatoryAssetModal: false,
      showMandatoryAssetButton:true,
    });

    this.setState({
      showMandatoryAssetButton: true, // Hide the button if the modal is closed
    });
  }

  ////Kiran-5705-PC/PNC-Lead Upload-Display Mandatory Assets
 startCountdown(expiryTime) {
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      const now = Date.now();
      const diff = expiryTime - now;
      if (diff <= 0) {
        clearInterval(this.timer);
        this.setState({ mandatoryTimer: "00 : 00 : 00" });
      } else {
        const h = String(Math.floor(diff / 3600000)).padStart(2, "0");
        const m = String(Math.floor((diff % 3600000) / 60000)).padStart(2, "0");
        const s = String(Math.floor((diff % 60000) / 1000)).padStart(2, "0");
        this.setState({ mandatoryTimer: `${h} : ${m} : ${s}` });
      }
    }, 1000);
  }

  

  /**
   * @author Sandeep Dhawale
   * @param  Description handle the campaignSpecificationPublisherDashboard
   * @return Description redirect to campaignSpecificationPublisherDashboard
   */

  displayCampaignSpecification(e) {
    //Sonali-3945-VAPT-get parameters from

    var campID = this.props.location.state.campID;
    var parentCampID = this.props.location.state.parentCampID;
    var reallocationID = this.props.location.state.reallocationID;

    // var campID = parsed.campID;//sandeep-task-3095-added URL parameter campID
    // var parentCampID = parsed.parentCampID;//sandeep-task-3095-added URL parameter parentCampID
    // var reallocationID = parsed.reallocationID;//sandeep-task-3095-added URL parameter reallocationID
    var key2 = this.state.key1; //shivani-task 3204-passes lead key to navigate back on the same page.
    //Sonali-3945-redirect to next page using history.push
    //Sonali-4032-adding into session storagr
    sessionStorage.setItem("campID", campID);
    sessionStorage.setItem("parentCampID", parentCampID);
    sessionStorage.setItem("reallocationID", reallocationID);
    sessionStorage.setItem("leadkey", key2);

    window.open("/campaignSpecificationPublisherDashboard");

    // ); //sunita-task-3099-added changes to open link in new tab
  }

  //   }
  /**
   * @author Shivani pathak (3204-task)
   * @param  Description handled pagination
   * @return Description return All the records as per pagination selected .
   */
  handleChangePageSize1(e) {
    var pageSize1 = e.target.value;
    this.setState({ pageSize1: pageSize1 });
  }

  /**
   * @author Shivani pathak(3204-task)
   * @param  Description handle the Status of the leads
   * @return Description return All leads as we filter out from status
   */
  //Rutuja task - 5598 commented  funtion and writtte new function for selectLead
  // selectLead(e) {
  //   var selectedLead = e.target.value;
  //   alert("test"+JSON.stringify(selectedLead))
  //   this.setState({ selectedLead: selectedLead });
  //   if (selectedLead === "All") {
  //     this.setState({ leadDetailsData: this.state.allDataArray });
  //   } else {
  //     var leadDetailsResponse = [...this.state.leadDetailsResponse];
  //     let filterleadDetails = leadDetailsResponse.filter((a) => {
  //       let status = a.status;
  //       status = status.toString().trim();
  //       status = status.split("|").join("");
  //       status = status.replace(/\s*,\s*/g, ",");
  //       status = status.split(",");
  //       return status.includes(selectedLead);
  //     });
  //     this.setState({ leadDetailsData: filterleadDetails });
  //   }
  // }
  //Rutuja task - 5598 written the new funtion for selectLead

  selectLead(e) {
    const selectedLead = e.target.value.trim(); // Clean the selected value
    this.setState({ selectedLead });

    // If "All" is selected, display all data
    if (selectedLead === "All") {
      this.setState({ leadDetailsData: this.state.allDataArray });
    } else {
      const { leadDetailsResponse } = this.state;

      // Filter leads based on matching status
      const filteredLeadDetails = leadDetailsResponse.filter((lead) => {
        // Iterate over each status in the status array for each lead
        return lead.status.some((statusItem) => {
          // Clean up the status item to remove extra spaces and normalize commas
          const cleanedStatus = statusItem
            .toString()
            .trim()
            .replace(/\s*,\s*/g, ","); // Clean up extra spaces around commas

          // Clean the selectedLead as well for consistent comparison
          const cleanedSelectedLead = selectedLead
            .toString()
            .trim()
            .replace(/\s*,\s*/g, ","); // Clean up spaces around commas

          // Compare cleaned status and selectedLead directly
          return cleanedStatus.includes(cleanedSelectedLead);
        });
      });

      this.setState({ leadDetailsData: filteredLeadDetails });
    }
  }
  /**
   * @author Shivani pathak(3204-task)
   * @param  Description handled filter data .
   * @return Description return as we filter out the status from dropdown .
   */
  filterResponseLead() {
    if (this.state.selectedLead !== "All") {
      var selectedLead = this.state.selectedLead;
      var leadDetailsResponse = this.state.leadDetailsResponse;
      let filterleadDetails = leadDetailsResponse.filter((a) => {
        return a.status.includes(selectedLead);
      });
      this.setState({ leadDetailsData: filterleadDetails });
    } else {
    }
  }

  /**
   * @author Narendra Phadke
   * @param  Description handle the file upload
   * @return Description return All details of file
   */

  handleChangeFileDeliverLead(e) {
    e.preventDefault();
    var fileName;
    var file = [];
    let headerErrors = {}; //Priyanka-4635
    e = document.createElement("input"); //creating a input element but not binding it to body added by sandeep
    e.setAttribute("type", "file"); //setting a attribute for type file added by sandeep
    e.setAttribute("multiple", true); //setting a attribute for multiple added by sandeep
    e.click(); //to open file dialougeadded by sandeep
    e.addEventListener(
      "change",
      function () {
        //calling an eventListener at change event added by sandeep
        let filesData = e.files[0];
        let filesData1 = e.files;
        var output = document.getElementById("LeadList");
        leadLength = filesData1.length;
        var extFileName = filesData.name;
        leadFileExt = extFileName.split(".").pop().toLowerCase();
        output.innerHTML = "<ul>";
        output.innerHTML += '<li id="fileUp">' + extFileName + "</li>";
        output.innerHTML += "</ul>";
        //sonali-3945-accessing parameters using this.props.location
        var campID = this.props.location.state.campID;
        var reAllocationID = this.props.location.state.reallocationID;
        var parentCampID = this.props.location.state.parentCampID;

        // const { isAuthenticated, user } = this.props.auth;  //Nilesh-4240-Removing console warnings

        if (this.validateForm(extFileName) === "false") {
          Swal.fire({
            text: "Please Upload only Excel(.xls, .xlsx, .csv) file", //Chaitanya-4550-added .csv in message
            type: "warning",
            confirmButtonText: "Ok",
            allowOutsideClick: false,
          });
          //kiran-4573-aaded swal fire for msg
          //Sandeep-task-3079-passsing filesData parameter in validateForm function
          return;
        } else {
          //Not insert file data into database only read file and get result into array
          // var wait = document.getElementById('pleaseWait');
          // alert("for wait=>"+wait)
          // wait.innerHTML="Please wait......";
          // this.setState({
          //   loading:" ",msg:"",//sandeep-task-3119-added code to set message
          // });
          // this.loadingRef.current.click();//Sandeep-task-3441-added code for loader
          this.setState({
            loading1: true,
            msg: "",
            headerErrors: headerErrors,
            loaderLead: "loader_uploadLead",
          });
          var clientDateTime = dateTime.create(); //Somnath Task-3403, Get current Date time as per specified dateTime
          clientDateTime = clientDateTime.format("Y-m-d H:M:S");
          var data = new FormData();
          data.append("campID", campID);
          data.append("parentCampID", parentCampID);
          //  data.append("userName",user.name); //kiran-bug 4253-removing username
          // data.append("pIDFile",user.id);//sonali-3945-removing pID from the following call
          data.append("reAllocationID", reAllocationID);
          data.append("file", filesData);
          data.append("clientDateTime", clientDateTime); //Somnath Task-3403, pass clientDateTime in body for leadInteractionDate validation
          data.append("leadFileExt", leadFileExt);

          //Chaitanya-4550-Added leadFileExt == "csv" condition in if block
          if (leadFileExt === "xlsx" || leadFileExt === "xls" || leadFileExt === "csv") {
            //Nilesh-4240-Removing console warnings
            //Sandeep-task-3119-removed localhost code from API
            fetch("lead/uploadFileForLeadDeliver", {
              method: "POST",
              body: data,
            })
              .then((res) => res.json())
              // .then((leadDetailsDataTest) => {
              // console.log("leadDetailsDataTest ==> ", leadDetailsDataTest);
              // Anshul-5813: fetching mapping fields in result
              .then((result) => {
                 //Nilesh-6005- Add BE message here
                if (result && result.success === false && result.message) {
                  headerErrors["error"] = result.message;

                  this.setState({
                    loading1: false,
                    loaderLead: "",
                    headerErrors: headerErrors,
                    leadDetailsData: [],
                    rejectlead: 0,
                  });

                  return;
                }
                let leadDetailsDataTest;
                let mappingFields;
                if (result.success === "false1" || result.success === false) {
                  leadDetailsDataTest = result;
                } else {
                     leadDetailsDataTest = result.leadData;
                  mappingFields = Array.isArray(result.mappingFields)
                    ? result.mappingFields
                    : [result.mappingFields];
                }

                //Aman-4567 Added this condtion to check if lead file length is <= 1900
                if (leadDetailsDataTest.success === "FileLengthIsGreater") {
                  //Aman-4567 Added this to remove loading loader
                  this.setState({
                    loading1: false,
                    msg: "",
                    headerErrors: headerErrors,
                    // loaderLead: "loader_uploadLead",//Anshul-5801: Removed loader when count is greater than 1900
                    loaderLead: "",
                  });

                  Swal.fire({
                    html: "<b>We are working to fix the current issue of large lead file uploads. Till that time, as a workaround, we request you to upload the lead files with leads upto 1900 leads maximum in one file.</b>",
                    type: "warning",
                    confirmButtonText: "Ok",
                    allowOutsideClick: false,
                    preConfirm: () => {
                      window.location.reload();
                    },
                  });
                  // fileInput.value = "";
                  return false;
                }

                if (leadDetailsDataTest.length > 0) {
                  //this.closeLoadingRef.current.click();//Sandeep-task3441-added loader
                  let formaterrors = {};
                  // const { isAuthenticated, user } = this.props.auth;   //Nilesh-4240-Removing console warnings
                  let result = {
                    leadDetailsData: leadDetailsDataTest,
                    // user:user,//sonali-3945-removing user from the following call
                    campID: campID,
                    parentCampID: parentCampID,
                    reallocationID: reAllocationID,
                    campaignLevelSwitch: this.state.campaignLevelSwitch,
                    DI_QA_Switch: this.state.DI_QA_Switch,
                    extFileName: extFileName, //Aman-4660 -MBAdmin-(to send filename)eport - Lead File Tracking Report- DMA's Upload lead file count and file details
                    mappingFields:mappingFields , //Anshul-5813
                  };

                  if (leadDetailsDataTest === undefined) {
                    formaterrors["format"] =
                      "Please upload correct format file";
                  } else {
                    fetch("/lead/updateLead", {
                      method: "POST",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify(result),
                    })
                      .then((res) => res.json())
                      .then((leadDetailsData) => {
                        //this.closeLoadingRef.current.click();//Sandeep-task3441-added loader
                        this.setState({
                          allDataArray: leadDetailsData,
                          rejectlead: leadDetailsData[0].rejectedLead,
                        });
                        //shivani-3204(3287)-filtered the status of the leads.
                        //kiran-4511-added if condition for internal review as in status filter dropdown it not show properly
                        //kiran-4514-declare count for showing proper status in dropdown
                        let leadfilter = [];
                        let count = 0;
                        for (let i = 0; i < leadDetailsData.length; i++) {
                          let status = leadDetailsData[i].status;
                          for (let j = 0; j < status.length; j++) {
                            if (leadDetailsData[i].status == "InternalReview") {
                              // datatype is object
                              count++;
                            } else {
                              let label = status[j];
                              label = label.trim();
                              label = label.split("|").join("").trim();
                              leadfilter.push({ status: status[j], label });
                            }
                          }
                        }
                        if (count > 0) {
                          let status = "InternalReview";
                          let label = status;
                          leadfilter.push({ status: status, label });
                        }
                        const result = Array.from(
                          new Set(leadfilter.map((p) => p.label))
                        ).map((label) => {
                          return {
                            label: label,
                            status: leadfilter.find((p) => p.label === label)
                              .status,
                          };
                        });
                        //Nilesh-4726- For finding invalid domain status
                        let statusResults = [];

                        for (let i = 0; i < leadDetailsData.length; i++) {
                          statusResults = leadDetailsData.filter((element) => {
                            return (
                              element.status.includes(
                                "REJECT_EMAIL_INVALID_DOMAIN"
                              ) ||
                              element.status.includes(
                                " | REJECT_EMAIL_INVALID_DOMAIN"
                              )
                            ); //Nilesh-4760-Add or status condition
                          });
                        }
                        //this.closeLoadingRef.current.click();//Sandeep-task3441-added loader
                        this.setState({
                          leadDetailsData,
                          leadDetailsResponse: leadDetailsData,
                          loading1: false,
                          leadfilter: result,
                          loaderLead: "",
                          statusResults: statusResults,
                          mappingFields:mappingFields //Anshul-5823
                        });

                        var status1;
                        //Nilesh-4240-Removing console warnings
                        /* Chaitanya-5868-Changed Email/Telemarketing to Email & Telemarketing*/
                        if (
                          leadDetailsData[0].marketingChannel ===
                            "TeleMarketing" ||
                          leadDetailsData[0].marketingChannel ===
                            "Email & Telemarketing"
                        ) {
                          for (var i = 0; i < leadDetailsData.length; i++) {
                            if (
                              leadDetailsData[i].status == "voiceLogPending" // datatype is object
                            ) {
                              status1 = true;
                            }
                          }
                          //shivani-task 3183-passed parentCampID to the link for backbutton fun on voice Logs Upload page.
                          if (status1 === true) {
                            //Nilesh-4240-Removing console warnings
                            document.getElementById(
                              "voiceLogLink"
                            ).style.display = "block";
                          }
                          //Rutuja task 5895 when there is "Email & Telemarketing channel but there is lead duplicate error then need to hide click here to upload voice log link button
                          else{
                            document.getElementById("voiceLogLink").style.display = "none";
                          }
                        }
                      });
                  }
                }
                //Sandeep-task-3119-added else block
                else {
                  //this.closeLoadingRef.current.click();//Sandeep-task3441-added loader
                  //setTimeout(function(){this.closeLoadingRef.current.click() ; }, 3000);//Sandeep-task-3441-added code for loader
                  //Priyanka - 4575 - Added condition to display invalid template error
                  //Priyanka-4635-Added different conditions to display error messages
                  if (leadDetailsDataTest.success === false) {
                    //Nilesh-4240-Removing console warnings
                    let response = leadDetailsDataTest.response;
                    //alert("response ==>"+JSON.stringify(response));
                    let file = response[0].file;
                    //alert(rejectedHeaders+"---"+missingHeaders+"---"+file);
                    if (file === true) {
                      //Nilesh-4240-Removing console warnings
                      let rejectHeader = response[0].rejectHeader;
                      let missingHeader = response[0].missingHeader;
                      let duplicateHeader = response[0].duplicateHeader;
                      //alert("duplicateHeader ==>"+JSON.stringify(response[0].duplicateHeader));
                      headerErrors["error"] =
                        "INVALID DELIVERY TEMPLATE - Please check below columns in the uploaded file header";
                      if (rejectHeader.length > 0) {
                        headerErrors["rejectedHeaders"] = "Mismatch Columns - ";
                      }
                      if (missingHeader.length > 0) {
                        headerErrors["missingHeaders"] = "Expected Columns - ";
                      }
                      if (duplicateHeader.length > 0) {
                        headerErrors["duplicateHeaders"] =
                          "Duplicate Columns - ";
                      } //Chaitanya-4719-Duplicate headers in delivery template due to CQ alias name
                      this.setState({
                        loading1: false,
                        loaderLead: "",
                        headerErrors: headerErrors,
                        rejectedHeaders: rejectHeader,
                        duplicateHeaders: duplicateHeader,
                        missingHeaders: missingHeader,
                        leadDetailsData: [],
                        rejectlead: 0, //Chaitanya-5661-When header error shows, reject lead count removed
                      });
                    } else {
                      // rutuja task 5903 changed DI to LN
                      headerErrors["error"] =
                        "INVALID DELIVERY TEMPLATE - Please use correct LN Delivery Template to upload leads"; //Rutuja task LN changed DI to LN
                      this.setState({
                        loading1: false,
                        loaderLead: "",
                        headerErrors: headerErrors,
                        leadDetailsData: [],
                        rejectlead: 0, //Chaitanya-5661-When header error shows, reject lead count removed
                      });
                    }
                  }
                  //Rutuja task 5567 if missing asset in lead file then show error
                  //Kiran Dhainje 5795 Added condition for missing asset error message from backend

                  else if (leadDetailsDataTest.success === "false1") {
                    let response = leadDetailsDataTest.response;
                    let missingAsset = response[0].missingAsset;
                    //console.log(missingAsset);
                    headerErrors["error"] =
                       response[0].message;
                    headerErrors["missingAsset"] = missingAsset;
                    this.setState({
                      loading1: false,
                      loaderLead: "",
                      headerErrors: headerErrors,
                      missingAsset: missingAsset,
                      leadDetailsData: [],
                      rejectlead: 0, //Chaitanya-5661-When header error shows, reject lead count removed
                    });
                  } else {
                    this.setState({
                      loading1: false,
                      // rutuja task 5903 changed DI to LN
                      msg: "Please upload LN template only",
                      loaderLead: "",
                    }); //Sandeep-task-3119-added code to stop loading and display error
                  }
                }
              })
              //Sandeep-task-3119-added catch block
              .catch(function (err) {
                console.log(err);
              });
          } /** End of else if Statement which check file extension */
          // else if (
          //   leadFileExt == "csv"
          // ) {
          //   fetch("/lead/uploadLeadDeliverCSV", {
          //     method: "POST",
          //     body: data,
          //   })
          //     .then((res) => res.json())
          //     .then((leadDetailsDataTest) => {
          //       if (leadDetailsDataTest.length > 0) {
          //         let formaterrors = {};

          //         // const { isAuthenticated, user } = this.props.auth;   //Nilesh-4240-Removing console warnings
          //         let result = {
          //           leadDetailsData: leadDetailsDataTest,
          //           // user:user,//sonali-3945-removing pID from the following call
          //           campID: campID,
          //           parentCampID: parentCampID,
          //           reallocationID: reAllocationID,
          //           campaignLevelSwitch: this.state.campaignLevelSwitch,
          //           DI_QA_Switch: this.state.DI_QA_Switch,
          //         };
          //         if (leadDetailsDataTest === undefined) {
          //           formaterrors["format"] =
          //             "Please upload correct format file";
          //         } else {
          //           this.updateLeadCount(result) // Nilesh-4757-Call the function
          //         }
          //       }
          //     });
          // }
          this.setState({
            filesData,
          });
        }
      }.bind(this)
    );
  }

  /**
   * @author Narendra Phadke
   * @param  Description submit the file
   * @return Description return All details of file
   */
  submitDeliverLead(e) {
    e.preventDefault();
    let formaterrors = {};
    //Sonali-3945-VAPT-get parameters from
    var campID = this.props.location.state.campID;
    // var parsed = queryString.parse(this.props.location.search);
    var parentCampID = this.props.location.state.parentCampID;
    var reallocationID = this.props.location.state.reallocationID;
    if (leadLength === undefined) {
      //Nilesh-4240-Removing console warnings
      return;
    } else {
      if (this.validateForm() === "false") {
        return;
      } else {
        // const { isAuthenticated, user } = this.props.auth;  //Nilesh-4240-Removing console warnings
        let result = {
          leadDetailsData: this.state.leadDetailsDataTest,
          // user:user,//sonali-3945-removing user from the following call
          campID: campID,
          parentCampID: parentCampID,
          reallocationID: reallocationID,
          campaignLevelSwitch: this.state.campaignLevelSwitch,
          DI_QA_Switch: this.state.DI_QA_Switch,
        };
        if (this.state.leadDetailsDataTest === undefined) {
          formaterrors["format"] = "Please upload correct format file";
        } else {
          ///
          fetch("/lead/updateLead", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(result),
          })
            .then((res) => res.json())
            .then((leadDetailsData) => {
              this.setState({ leadDetailsData: leadDetailsData });
              var status1;
              // alert("leadDetailsData[0].marketingChannel---- >>" + JSON.stringify(leadDetailsData[0].marketingChannel))
              // alert("leadLength=== >>>>" + typeof(leadDetailsData[0].marketingChannel))
              /* Chaitanya-5868-Changed Email/Telemarketing to Email & Telemarketing*/
              if (
                leadDetailsData[0].marketingChannel == "TeleMarketing" ||
                leadDetailsData[0].marketingChannel == "Email & Telemarketing"
              ) {
                for (var i = 0; i < leadDetailsData.length; i++) {
                  if (leadDetailsData[i].status == "voiceLogPending") {
                    status1 = true;
                  }
                }
                //shivani-task 3183-passed parentCampID to the link for backbutton fun on voice Logs Upload page.
                if (status1 == true) {
                  document.getElementById("voiceLogLink").style.display =
                    "block";
                }
                //Rutuja task 5895 when there is "Email & Telemarketing channel but there is lead duplicate error then need to hide click here to upload voice log link button
                else{
                document.getElementById("voiceLogLink").style.display = "none";
                }
              }
            });

          ////
        }
      }
    }
  }

  validateForm(filesData1 = "") {
    //Sandeep-task-3079-accessing filesData parameter in validateForm function

    var pclick = document.getElementById("pleaseClick");
    pclick.innerHTML = "";
    let formIsValid = true;
    let errors = {};
    let fileerrors = {};

    var campFileExt;
    if (this.state.getExt === "Excel") {
      //Nilesh-4240-Removing console warnings
      campFileExt = "xlsx";
    } else if (this.state.getExt === "CSV") {
      //Nilesh-4240-Removing console warnings
      campFileExt = "csv";
    }

    if (leadLength === undefined) {
      //Nilesh-4240-Removing console warnings
      errors["file"] = "Please upload minimum one excel file";
      formIsValid = "false";
    }

    if (leadLength !== undefined) {
      var allowedFiles = [".xls", ".xlsx", ".csv"]; //Chaitanya-4550- Added .csv extention
      //var allowedFiles = [".xls", ".xlsx"];//kiran-4573-removed .csv file

      var deliveryLeadfiles = filesData1; //sandeep-task-3079-filesData1 stored into deliveryLeadfiles
      var regex = new RegExp(
        "([a-zA-Z0-9s_\\.()-:])+(" + allowedFiles.join("|") + ")$"
      );
      if (!regex.test(deliveryLeadfiles.toLowerCase())) {
        //Sandeep-task-3079-accessing deliveryLeadfiles with .name to access Leadfile name
        fileerrors["fileextensions"] =
          "Please upload files having extensions: " +
          allowedFiles.join(", ") +
          " only";
        formIsValid = "false";
      }
    }
    this.setState({
      errors: errors,
      fileerrors: fileerrors,
    });

    return formIsValid;
  }
  /**
   * @author Somnath Keswad
   * @param  Description Write the data in Excel File
   * @return Description Download the Excel File
   */

  downloadAuditReport(e) {
    e.preventDefault();
    var campID = e.target.id;
    // alert("campID ==>>" + JSON.stringify(campID))
    // var campID = this.props.location.state.campID; //Nilesh-4240-Removing console warnings
    // alert("campID ---->>" + JSON.stringify(campID))
    var parentCampID = this.props.location.state.parentCampID;
    var reAllocationID = this.props.location.state.reallocationID;
    // const { isAuthenticated, user } = this.props.auth;  //Nilesh-4240-Removing console warnings

    let data = {
      campID: campID,
      parentCampID: parentCampID,
      reallocationID: reAllocationID,
      listLeadInfoID: this.state.leadDetailsData,
      mappingFields: this.state.mappingFields, //Anshul-5823
      //  user: user//sonali-3945-removing user from the following call
    };

    fetch("publisher/downloadAuditReport", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      // .then((res) => res.json())
      // .then((downloadFiles) => {
      //   this.setState({ downloadFiles: downloadFiles });

      //   if (downloadFiles.length > 0) {
      //     var ws = xlsx.utils.json_to_sheet(downloadFiles);
      //     var wb = xlsx.utils.book_new();
      //     xlsx.utils.book_append_sheet(wb, ws, "Lead");
      //     var wbout = xlsx.write(wb, { bookType: "xlsx", type: "array" });
      //     var fileName =
      //       "Audit_Report" + parentCampID + "-" + reAllocationID + ".xlsx";
      //     saveAs(new Blob([wbout], { type: "application/octet-stream" }), fileName);
      //   } else {
      //   }
      // });

      // Anshul-5813: commented above code, fetching file directly from backend
        .then((res) => {
    if (!res.ok) throw new Error("Failed to download audit report");
    return res.blob();
  })
  .then((blob) => {
    const fileName = `Audit_Report_${parentCampID || ""}-${reAllocationID || ""}.xlsx`;

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    a.remove();
    window.URL.revokeObjectURL(url);

    Swal.fire({
      title: "Download Completed",
      type:'success',
      text: "Audit Report has been downloaded successfully!",
      icon: "success",
      confirmButtonText: "OK",
   
      confirmButtonColor: "#144a9bff",
    });
  })
  .catch((error) => {
    console.error("Error downloading Excel report:", error);
    Swal.fire({
      title: "Error",
      type:"error",
      text: "Failed to download the Audit Report. Please try again.",
      icon: "error",
      confirmButtonText: "OK",
    });
  });
  }

  handleChangeSearch(e) {
    e.preventDefault();
    let currentList = [];
    let newList = [];
    let filterData = e.target.value;
    if (e.target.value === "") {
      newList = this.state.leadDetailsData;
    } else {
      currentList = this.state.leadDetailsData;
      newList = currentList.filter((item) => {
        const lc = item;
        const filter = e.target.value.toLowerCase();
        var data = Object.values(lc);
        var dataFinal = data.toString();
        dataFinal = dataFinal.replace(",", " ");
        var dataToLower = dataFinal.toLowerCase();
        return dataToLower.includes(filter);
      });
    }
    this.setState({
      columnSearch: [...newList],
      tableSearchText: filterData,
    });
  }

  //Nilesh-4726-For this function use for changing checkbox value
  onChangeDoaminCheckbox = (e) => {
    this.setState({
      domainChecked: e.target.checked,
    });
  };

  //Nilesh-4726-For this function use for invalid domain to valid
  offDomainValidation = (e) => {
    e.preventDefault();
    const result = this.state.statusResults;
    // const { user } = this.props.auth;  //Nilesh-4240-Removing console warnings

    let data = {
      result,
      campaignDetail: [
        {
          domainChecking: this.state.domainChecked ? "OFF" : "ON",
        },
      ],
    };

    this.setState({
      loading1: true,
      msg: "",
      loaderLead: "loader_uploadLead",
    });
    fetch("/validateEmail/notValidateDomain", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((results) => {
        this.setState({
          loading1: false,
          loaderLead: "",
          results: results,
        });

        let statusResults = this.state.statusResults;
        let mainArray = this.state.leadDetailsData;

        for (let i = 0; i < this.state.results.length; i++) {
          for (let j = 0; j < mainArray.length; j++) {
            if (this.state.results[i].leadInfoID === mainArray[j].leadInfoID) {
              mainArray[j].status = this.state.results[i].status;

              statusResults = this.state.results.filter((element) => {
                return (
                  element.status.includes("REJECT_EMAIL_INVALID_DOMAIN") ||
                  element.status.includes(" | REJECT_EMAIL_INVALID_DOMAIN")
                ); //Nilesh-4760-Add or status condition
              });
              break; // Exit the inner loop once the match is found
            }
          }
        }

        //Nilesh-4757- call for updateLeadCount function
        let result = {
          leadDetailsData: mainArray,
          // user:user,//sonali-3945-removing pID from the following call
          campID: this.state.campID,
          parentCampID: this.state.parentCampID,
          reallocationID: this.state.reAllocationID,
          campaignLevelSwitch: this.state.campaignLevelSwitch,
          DI_QA_Switch: this.state.DI_QA_Switch,
        };
        this.updateLeadCount(result);

        this.setState({
          loading1: false,
          loaderLead: "",
          //leadDetailsData: mainArray,
          statusResults: statusResults,
          // result: result
        });
      })
      .catch((error) => {
        // Handle any errors that occur during the fetch request
        console.error("Error:", error);
      });
  };

  // Nilesh-4757- This function fetching updateLead route
  updateLeadCount(result) {
    fetch("/lead/updateLead", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(result),
    })
      .then((res) => res.json())
      .then((leadDetailsData) => {
        //this.closeLoadingRef.current.click();//Sandeep-task3441-added loader
        this.setState({
          allDataArray: leadDetailsData,
          rejectlead: leadDetailsData[0].rejectedLead,
        });
        //shivani-3204(3287)-filtered the status of the leads.
        //kiran-4511-added if condition for internal review as in status filter dropdown it not show properly
        //kiran-4514-declare count for showing proper status in dropdown
        let leadfilter = [];
        let count = 0;
        for (let i = 0; i < leadDetailsData.length; i++) {
          let status = leadDetailsData[i].status;
          for (let j = 0; j < status.length; j++) {
            if (leadDetailsData[i].status == "InternalReview") {
              count++;
            } else {
              let label = status[j];
              label = label.trim();
              label = label.split("|").join("").trim();
              leadfilter.push({ status: status[j], label });
            }
          }
        }
        if (count > 0) {
          let status = "InternalReview";
          let label = status;
          leadfilter.push({ status: status, label });
        }
        const result = Array.from(new Set(leadfilter.map((p) => p.label))).map(
          (label) => {
            return {
              label: label,
              status: leadfilter.find((p) => p.label === label).status,
            };
          }
        );
        //Nilesh-4726- For finding invalid domain status
        let statusResults = [];
        for (let i = 0; i < leadDetailsData.length; i++) {
          statusResults = leadDetailsData.filter((element) => {
            return element.status.includes("REJECT_EMAIL_INVALID_DOMAIN");
          });
        }

        //this.closeLoadingRef.current.click();//Sandeep-task3441-added loader
        this.setState({
          leadDetailsData,
          leadDetailsResponse: leadDetailsData,
          loading1: false,
          leadfilter: result,
          loaderLead: "",
          statusResults: statusResults,
        });

        var status1;
        // alert("----+>" + JSON.stringify(leadDetailsData[0].marketingChannel))
        // alert("====+>" + typeof(leadDetailsData[0].marketingChannel))
        /* Chaitanya-5868-Changed Email/Telemarketing to Email & Telemarketing*/
        if (
          leadDetailsData[0].marketingChannel == "TeleMarketing" ||
          leadDetailsData[0].marketingChannel == "Email & Telemarketing"
        ) {
          for (var i = 0; i < leadDetailsData.length; i++) {
            if (leadDetailsData[i].status == "voiceLogPending") {
              status1 = true;
            }
          }
          //shivani-task 3183-passed parentCampID to the link for backbutton fun on voice Logs Upload page.
          if (status1 == true) {
            document.getElementById("voiceLogLink").style.display = "block";
          }
          //Rutuja task 5895 when there is "Email & Telemarketing channel but there is lead duplicate error then need to hide click here to upload voice log link button
          else{
            document.getElementById("voiceLogLink").style.display = "none";
          }
        }
      });
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

    //Nilesh-6004-Added to show help modal
  handleHelp = () => {
    this.setState({ showHelpModal: true });
  };
  //Nilesh-6004-Added to close help modal
  handleCloseHelp = () => {
    this.setState({ showHelpModal: false });
  };
  //Nilesh-6004-Added to handle search
  handleSearch = (e) => {
    this.setState({ searchText: e.target.value.toLowerCase() });
  };

  render() {
    // const { isAuthenticated, user } = this.props.auth;
    const { user } = this.props.auth; //Nilesh-4240-Removing console warnings

    const column1 = [
      {
        title: "Lead ID",
        dataIndex: "leadInfoID",
        key: "leadInfoID",
        width: "5%",
        align: "left", //Sandeep-task-3441-algin table data to left

        render: (text, record) =>
          record.status == "InternalReview" ? (
            <div style={{ color: "green" }}>{record.leadInfoID}</div>
          ) : (
            <div style={{ color: "red" }}>{record.leadInfoID}</div>
          ),
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
        width: "15%",
        align: "left", //Sandeep-task-3441-algin table data to left
        render: (text, record) =>
          record.status == "InternalReview" ? (
            <div style={{ color: "green" }}>{record.email}</div>
          ) : (
            <div style={{ color: "red" }}>{record.email}</div>
          ),
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        width: "30%",
        align: "left", //Sandeep-task-3441-algin table data to left
        render: (text, record) =>
          record.status == "InternalReview" ? (
            <div style={{ color: "green" }}>{record.status}</div>
          ) : (
            <div style={{ color: "red" }}>{record.status}</div>
          ),
      },
    ];
    // let locale = {  emptyText: " ", }; //Sandeep-task-3341  //Nilesh-4240-Removing console warnings

    const result = Array.from(
      new Set(this.state.leadDetailsData.map((p) => p.totalLead))
    ).map((totalLead) => {
      return {
        totalLead: totalLead,
        acceptedLead: this.state.leadDetailsData.find(
          (p) => p.totalLead === totalLead
        ).acceptedLead,
        rejectedLead: this.state.leadDetailsData.find(
          (p) => p.totalLead === totalLead
        ).rejectedLead,
        voiceLogLead: this.state.leadDetailsData.find(
          (p) => p.totalLead === totalLead
        ).voiceLogLead,
      };
    });

    return (
         <div>
        {/* Nilesh-6004-model code */}
        {this.state.showHelpModal && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.6)",
      backdropFilter: "blur(4px)",
      zIndex: 9999,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <div
      style={{
        width: "85%",
        maxWidth: "1000px",
        background: "#fff",
        borderRadius: "12px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
        overflow: "hidden",
        animation: "fadeIn 0.3s ease-in-out",
      }}
    >
      
      {/* Header */}
      <div
        style={{
          background: "#144999",
          color: "#fff",
          padding: "12px 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h4 style={{ margin: 0, color: "white", textAlign: "center",  width: "100%" }}>Lead Upload Help</h4>

        <button
          onClick={this.handleCloseHelp}
          style={{
            background: "transparent",
            border: "none",
            color: "#fff",
            fontSize: "24px",
            cursor: "pointer",
          }}
        >
          &times;
        </button>
      </div>

     {/* Body */}
<div
  style={{
    height: "420px", 
    overflowY: "auto",
    padding: "0px 20px 20px 20px", // top padding removed for sticky
    position: "relative"
  }}
>

  {/* SEARCH BOX (STICKY) */}
  <div
    style={{
      position: "sticky",
      top: 0,
      zIndex: 3,
      background: "#fff",
      paddingTop: "20px",
      paddingBottom: "10px"
    }}
  >
    <input
      type="text"
      placeholder="Search error..."
      onChange={(e) =>
        this.setState({ searchText: e.target.value.toLowerCase() })
      }
      style={{
        width: "100%",
        padding: "8px",
        borderRadius: "5px",
        border: "1px solid #ccc",
        fontSize: "13px",
        outline: "none",
        transition: "all 0.3s ease"
      }}
      onFocus={(e) => {
        e.target.style.border = "1px solid #007bff";
        e.target.style.boxShadow = "0 0 5px rgba(0,123,255,0.5)";
      }}
      onBlur={(e) => {
        e.target.style.border = "1px solid #ccc";
        e.target.style.boxShadow = "none";
      }}
    />
  </div>

  {/* TABLE */}
  <table
    className="table table-bordered"
    style={{
      tableLayout: "fixed",
      width: "100%",
      marginBottom: 0
    }}
  >
    {/* HEADER STICKY BELOW SEARCH */}
    <thead
      style={{
        background: "#f1f1f1",
        position: "sticky",
        top: "58px", // IMPORTANT (search height)
        zIndex: 3,
      }}
    >
      <tr>
        <th style={{ width: "10%", padding: "6px 8px",  textAlign: "center"}}>Sr.No</th>
        <th style={{ width: "45%", padding: "6px 8px", textAlign: "center"}}>Validation Message</th>
        <th style={{ width: "45%", padding: "6px 8px", textAlign: "center"}}>Details</th>
      </tr>
    </thead>

   <tbody>
  {(() => {
    const filteredData = [
  { no: 1, name: "REJECT_PUBLISHER_ID_WRONG", reason: "The provided publisher ID is incorrect or does not exist in the system." },
  { no: 2, name: "REJECT_CAMPID_WRONG", reason: "The campaign ID is invalid or not mapped to the current campaign." },
  { no: 3, name: "REJECT_LEAD_INTERACTION_DATE", reason: "The interaction date is missing, incorrectly formatted, or not within the allowed range." },
  { no: 4, name: "REJECT_FIRSTNAME_INVALID", reason: "First name is missing, contains invalid characters, or does not meet format rules." },
  { no: 5, name: "REJECT_LASTNAME_INVALID", reason: "Last name is missing, contains invalid characters, or does not meet format rules." },
  { no: 6, name: "REJECT_EMPLOYEE_SIZE_INVALID", reason: "Employee size value does not align with the campaign specification. Please select a valid Employee size." },
  { no: 10, name: "REJECT_WRONG_ASSET_NAME", reason: "Asset Name value does not align with the campaign specification. Please select a valid Asset Name." },
  { no: 12, name: "REJECT_EMAIL_SUPPRESSION", reason: "Email exists in the suppression list and cannot be processed." },
  { no: 13, name: "REJECT_EMAIL_EXCLUSION", reason: "Email is marked in the exclusion list and is not eligible." },
  { no: 14, name: "REJECT_ZIPCODE_SAME_FOR_MULTIPLE_CITY", reason: "The ZIP code corresponds to multiple cities, causing ambiguity." },
  { no: 15, name: "REJECT_CITY_INVALID", reason: "City name is missing, invalid, or not recognized." },
  { no: 16, name: "REJECT_ZIPCODE_INVALID", reason: "ZIP/postal code is missing, invalid, or not in correct format." },
  { no: 17, name: "REJECT_WRONG_PHONE_NUMBER", reason: "Phone number is missing, incorrectly formatted, or invalid." },
  { no: 18, name: "REJECT_EMAIL_NOT_VALID_DOMAIN_COUNTRY", reason: "Email domain does not match the expected country/domain rules." },
  { no: 19, name: "REJECT_LEAD_DUPLICATE_IN_DB_FN_LN_CN", reason: "A lead with the same first name, last name, and company already exists in the database." },
  { no: 20, name: "REJECT_LEAD_DUPLICATE_IN_FILE_FN_LN_CN", reason: "Duplicate lead found within the uploaded file based on name and company." },
  { no: 21, name: "REJECT_LEAD_DUPLICATE_IN_FILE", reason: "Exact duplicate record detected within the same file." },
  { no: 22, name: "REJECT_LEAD_DUPLICATE", reason: "Lead is identified as a duplicate based on system validation rules." },
  { no: 23, name: "REJECT_EMAIL_INVALID_DOMAIN", reason: "Email domain is invalid, not recognized, or fails validation checks." },
  { no: 24, name: "REJECT_LEAD_DUPLICATE_IN_FILE_FN_LN_DOMAIN", reason: "The lead entry is a duplicate within the uploaded file itself, identified by matching first name, last name, and email domain." },
  { no: 25, name: "REJECT_LEAD_DUPLICATE_IN_DB_FN_LN_DOMAIN", reason: "A lead with the same first name, last name, and email domain already exists in the database, preventing duplicate entries." },
  { no: 26, name: "REJECT_LEAD_EMAIL_BLANK", reason: "The lead’s email field is empty or missing, which is required for processing." },
  { no: 27, name: "REJECT_EMAIL_FORMAT", reason: "The email address provided is not in a valid format (e.g., missing '@' or domain)." },
  { no: 28, name: "REJECT_EMAIL_NOT_ABM", reason: "The email address is not part of the approved Account-Based Marketing (ABM) target list." },
  { no: 29, name: "REJECT_EMAIL_DUE_TO_PER_LEAD", reason: "Email rejected due to per-lead policies or restrictions that apply to this record." },
  { no: 30, name: "REJECT_GENERIC_EMAIL_KEYWORD", reason: "The email contains generic or suspicious keywords that cause it to be flagged and rejected." },
  { no: 31, name: "REJECT_EMAIL_SOCIAL_DOMAIN", reason: "Email domain belongs to social or free email providers (like Gmail, Yahoo) which are not accepted in this context." },
  { no: 32, name: "REJECT_LEAD_DUE_TO_EXCLUDED_DOMAIN_EXTENSION", reason: "The lead’s email domain extension (e.g., .xyz, .club) is excluded from processing." },
  { no: 33, name: "REJECT_COMPANYNAME_INVALID", reason: "The company name field is missing, invalid, or does not conform to required standards." },
  { no: 34, name: "REJECT_FN_LN_SAME_INVALID", reason: "The first name and last name are identical or invalid, which is not allowed." },
  { no: 35, name: "REJECT_DUPLICATE_LEAD_SAME_CLIENT_ALL_CAMPAIGNS", reason: "The lead already exists for the same client across all campaigns and cannot be duplicated." },
  { no: 36, name: "REJECT_LP_LINK_NOT_APPROVED", reason: "The landing page URL provided has not been approved for use." },
  { no: 37, name: "REJECT_CS_LINK_NOT_APPROVED", reason: "The customer service link provided is not approved or valid." },
  { no: 38, name: "REJECT_LP/CS_NOT_APPROVED", reason: "Either the landing page or customer service link fails approval checks." },
  { no: 39, name: "REJECT_WRONG_ASSET_ID", reason: "The asset ID provided is incorrect or does not exist in the system." },
  { no: 40, name: "REJECT_ASSET_ID_MISMATCH_WITH_ASSET_NAME", reason: "The asset ID does not correspond to the given asset name, indicating a mismatch." },
  { no: 41, name: "REJECT_BLANK_LEAD_INTERACTION_DATE", reason: "The interaction date for the lead is missing and must be provided." },
  { no: 42, name: "REJECT_LEAD_INTERACTION_DATE_TIMESTAMP_WRONG", reason: "The timestamp format of the lead interaction date is incorrect or malformed." },
  { no: 43, name: "REJECT_LEAD_INTERACTION_DATE_INVALID_FORMAT", reason: "The interaction date is not in the expected date format." },
  { no: 44, name: "REJECT_COUNTRY_INVALID", reason: "The country name or code provided is invalid or not recognized." },
  { no: 45, name: "REJECT_STATE_INVALID", reason: "The state or province information is missing, invalid, or unrecognized." },
  { no: 46, name: "REJECT_INDUSRTY_INVALID", reason: "The industry field is invalid, misspelled, or not part of the accepted list." },
  { no: 47, name: "REJECT_JOBLEVEL_INVALID", reason: "The job level does not match any of the accepted categories." },
  { no: 48, name: "REJECT_JOBFUNCTION_INVALID", reason: "The job function field contains invalid or unrecognized values." },
  { no: 49, name: "REJECT_JOBTITLE_INVALID", reason: "The job title is missing or invalid as per the defined criteria." },
  { no: 50, name: "REJECT_WRONG_COUNTRY_PHONE_CODE", reason: "The phone number’s country code is incorrect or does not match the country." },
  { no: 51, name: "REJECT_WRONG_COUNTRY_PHONE_FORMAT", reason: "The phone number format is invalid for the specified country." },
  { no: 52, name: "REJECT_COMPANY_REVENUE_INVALID", reason: "The company revenue data is missing, invalid, or out of acceptable range." },
  { no: 53, name: "REJECT_ZIPCODE_SAME_FOR_MULTIPLE_COUNTRY", reason: "The ZIP/postal code is linked to multiple countries, causing ambiguity." },
  { no: 54, name: "REJECT_INDUSTRY_EXCLUDED", reason: "The lead’s industry is excluded from this campaign or data processing." },
  { no: 55, name: "REJECT_CITY_INVALID_INPUT", reason: "The city field contains invalid data or is missing." },
  { no: 56, name: "REJECT_STATE_INVALID_INPUT", reason: "The state field contains invalid data or is missing." },
  { no: 57, name: "REJECT_EMAIL_STATUS_WRONG_VALUE", reason: "The email status field contains a value that is invalid or not recognized." },
  { no: 58, name: "REJECT_ESP_STATUS_WRONG_VALUE", reason: "The email service provider status has an invalid or unexpected value." },
  { no: 59, name: "REJECT_ALLOCATIONID_WRONG", reason: "The allocation ID provided is invalid or does not correspond to the system’s records." },
  { no: 60, name: "REJECT_QUESTION_ALIAS_NAME", reason: "The alias name for the question is missing or invalid." },
  { no: 61, name: "REJECT_QUESTION_ALIAS_NAME_NOT_FOUND", reason: "The specified question alias name could not be found in the system." },
  { no: 62, name: "REJECT_QUESTION_QUESTION_NOT_FOUND", reason: "The referenced question does not exist or is missing from the data." }
].filter(item => {
      const search = this.state.searchText || "";
      return (
        item.name.toLowerCase().includes(search) ||
        item.reason.toLowerCase().includes(search)
      );
    });

    // If no data found
    if (filteredData.length === 0) {
      return (
        <tr>
          <td colSpan="3" style={{ textAlign: "center", padding: "20px", color: "#888" }}>
            No Data Found
          </td>
        </tr>
      );
    }

    // Normal data render
    return filteredData.map((item, index) => (
      <tr key={index}>
        <td style={{ padding: "6px 8px", fontSize: "12px", textAlign: "center" }}>{item.no}</td>

        <td style={{ color: "red", padding: "6px 8px", fontSize: "12px" }}>
          {item.name}
        </td>

        <td style={{ padding: "6px 8px", fontSize: "12px" }}>
          {item.reason}
        </td>
      </tr>
    ));
  })()}
</tbody>
  </table>
</div>

    </div>
  </div>
)}
        {/* Sandeep-task-3499-removed old loader */}
        {/* <LeadReviewLoader
					loadingRef={this.loadingRef}
					closeLoadingRef={this.closeLoadingRef}
					message="Please wait...Leads are validating.."
				/> */}
        {/* Sandeep-task-3341-added code for loader */}
        <PublisherNavigation />
        <br />
        <div
          class="container-fluid"
          style={{
            paddingBottom: "150px",
            paddingTop: "70px",
            overflowX: "hidden",
          }}
        >
          {/*sunita-task-3067-added code to hide the scrollbar. */}
          <div class="row">
            <div class="col-sm-12 col-md-1 col-lg-2">
              <a
                href="#/" //Nilesh-4240-Removing console warnings
                style={{
                  // color: "#fff", //Nilesh-4240-Removing console warnings
                  color: "#056eb8",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  this.props.history.push("/publisherCampaignList", {
                    pID: user.id,
                  });
                }}
              >
                <FaArrowAltCircleLeft
                  size={32}
                  title="Back to publisherCampaignList"
                />
              </a>
            </div>
            <div class=" col-xs-12 col-sm-12 col-md-8 col-lg-7" align="center">
              {/* //shivani-3308-passed ID for DI label consistency */}
              <label id="labelDI">
                Leads Delivery
                <span id="labelDI">
                  (Campaign ID:{this.props.location.state.parentCampID})
                </span>
              </label>
            </div>

            {/*Kiran D -5705-PC/PNC-Lead Upload-Display Mandatory Assets */}

            <div
              className="col-sm-12 col-md-3 col-lg-3"
              align="left"
              style={{
                color: "#000080",
                fontSize: "18px",
                paddingLeft: "20px",
                position: "relative",
                marginLeft:"-101px"
              }}
            >
              {/* Button Section */}
              <div style={{ display: "flex", gap: "12px" }}>
              {/* {alert("this.state.showMandatoryAssetButton -->" + JSON.stringify(this.state.showMandatoryAssetButton))} */}
                {this.state.showMandatoryAssetButton && !this.state.hideButtonAfterTimer ? (
                   <div className="tooltip-wrapper">
                   <button
                      className="btn add-button"
                   onClick={this.handleButtonClick}
                       >
                         Mandatory Assets
                           </button>
                          <div className="custom-tooltip">View Mandatory Assets</div>
                          </div>
                          ) : (
                       <div style={{ width: "150px" }}></div>
                            )}


                <div className="tooltip-wrapper">
                  <button
                    className="btn add-button"
                    onClick={this.displayCampaignSpecification}
                  >
                    Campaign Specification
                  </button>
                </div>
                 {/* Nilesh-6004-Added help button */}
                 <div className="tooltip-wrapper">
                  <button
                    className="btn add-button"
                    onClick={this.handleHelp}
                  >
                    Help
                  </button>
                </div>
              </div>
              {/* Modal */}
              {this.state.showMandatoryAssetModal && (
                
                <div
                  className="custom-modal-overlay"
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0,0,0,0.5)",
                    zIndex: 1050,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    paddingTop: "70px",
                    overflowY: "auto",
                  }}
                >
                  <div
                    className="modal-dialog"
                    style={{
                      backgroundColor: "#fff",
                      borderRadius: "8px",
                      maxWidth: "95%",
                      minWidth: "600px",
                      margin: "20px",
                      maxHeight: "80vh",
                      overflow: "hidden",
                    }}
                  >
                    <div className="modal-content">
                      {/* Header */}
                      <div
                        className="modal-header custom-classPopup"
                        style={{
                          backgroundColor: "#007bff",
                          color: "#fff",
                          padding: "5px 20px",
                          textAlign: "center",
                          position: "relative",
                        }}
                      >
                        <h4
                          style={{
                            marginTop: "10px",
                            marginBottom: "5px",
                            fontFamily: "Roboto",
                            fontSize: "18px",
                            background: "#144999",
                          }}
                        >
                          {this.state.campID} - Mandatory Assets
                        </h4>
                        <button
                          type="button"
                          className="close"
                          style={{
                            fontSize: 24,
                            color: "#fff",
                            border: "none",
                            background: "transparent",
                            position: "absolute",
                            top: "50%",
                            right: "15px",
                            transform: "translateY(-50%)",
                          }}
                          onClick={this.handleCloseModal}
                        >
                          &times;
                        </button>
                      </div>

                      {/* Timer + Note */}
                      {/*Kiran Dhainje 5736 PAT Issue-PC-Lead Upload-Mandatory Asset remove the time header 19-08-2025 */}

                <div style={{ padding: "15px 20px", textAlign: "center" }}>
                  <div
                           style={{
                          color: "Red",
                          fontWeight: "bold",
                         fontSize: "18px",
                          }}
                        >
                          
                      {/*Kiran Dhainje 5736 PAT Issue-PC-Lead Upload-Mandatory Asset page showing wrong count */}
                      {/*Kiran Dhainje 5736 PAT Issue-PC-Lead Upload-Mandatory Asset remove the time header 19-08-2025 */}
                        </div>
                           
                            <div style={{ color: "#FFA500", fontSize: "14px" }}>
                           Assets marked with an asterisk (
                           <span style={{ color: "red" }}>*</span>) are mandatory for a successful Lead Upload
                               </div>
                                  </div>


                      {/* Table Content */}
                      <div
                        className="modal-body"
                        style={{
                          paddingLeft: "50px",
                          paddingRight: "50px",
                          paddingBottom: "30px",
                          paddingTop: "3px",
                          overflowY: "auto",
                          maxHeight: "60vh",
                          fontSize: "13px",
                        }}
                      >
                        <table
                          className="table table-bordered mb-0"
                          style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            marginBottom: 0,
                            tableLayout: "fixed",
                          }}
                        >
                          <thead className="bg-light">
                            <tr>
                              <th
                                style={{
                                  backgroundColor: "lightgray",
                                  textAlign: "center",
                                  padding: "12px 10px", // changed
                                  fontWeight: 600,
                                  fontSize: "13px",
                                  border: "1px solid #dee2e6",
                                  verticalAlign: "middle",
                                  boxSizing: "border-box",
                                }}
                              > {/* Kiran 5739 PC-Lead Upload-Display Client Asset ID on Mandatory Asset Popup */}
                               {this.state.isMultiTouch
                                ? "1st Touch"
                                : this.state.assetIdCheck ? "Asset ID" 
                                : "LN Asset ID"}
{/* rutuja task 5901 chabged DI asset ID to LN asset ID */}
                              </th>
                              <th
                                style={{
                                  backgroundColor: "lightgray",
                                  textAlign: "center",
                                  padding: "12px 10px", // changed
                                  fontWeight: 600,
                                  fontSize: "13px",
                                  border: "1px solid #dee2e6",
                                  verticalAlign: "middle",
                                  boxSizing: "border-box",
                                }}
                              >
                                {this.state.isMultiTouch
                                  ? "2nd Touch"
                                  : "Asset Name"}
                              </th>
                            </tr>
                          </thead>
                       <tbody> {/* Kiran 5772 Prod Issue-PC-Lead Upload-Mandatory Assets page showing blank */}
                       {(this.state.isMultiTouch ? this.state.multitouchConfigData : this.state.validData).map((row, index) => (
                                                <tr key={index}>
                                                <td
                                             style={{
                                           padding: "12px 10px",
                                     verticalAlign: "middle",
                                      textAlign: "center",
                                     border: "1px solid #dee2e6",
                                     boxSizing: "border-box",
                                         wordWrap: "break-word",
                                                    }}
                                                   > 
                                         {row.allowFlag === "Yes" && (
                                        <span style={{ color: "red" }}>*</span>
                                             )}
                                           {this.state.isMultiTouch
                                            ? row.firstTouch || "-"
                                            : this.state.assetIdCheck
                                            ? row.keyword || "-"
                                            : row.supportDocID || "-"}
                                                      </td>
                                                      <td
                                                     style={{
                                                  padding: "12px 10px",
                                                 verticalAlign: "middle",
                                               textAlign: "center",
                                             border: "1px solid #dee2e6",
                                              boxSizing: "border-box",
                                            wordWrap: "break-word",
                                           }}
                                         >
                                   {/* kiran Dhainje 5772 Prod Issue-PC-Lead Upload-Mandatory Assets page showing blank */}
                                   {this.decodeIfEncoded(row.secondTouch || row.suppDocName || "-")}
                                   </td>
                                 </tr>
                                  ))}
                            </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              
              &nbsp;
            </div>
          </div>

          <div></div>

          <hr />

          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="card-body">
              <MDBRow>
                <MDBCol lg="4">
                  <div class="row" style={{ marginLeft: "10px" }}>
                    <div>
                      <button
                        id="file"
                        class="btn11 info11"
                        onClick={this.handleChangeFileDeliverLead}
                        style={{ fontWeight: "500" }}
                      >
                        Upload Lead{" "}
                      </button>

                      {/* sandeep-task-3079-removing input element added onclick event with button to upload LeadFile */}
                      {/* <input type="file"  id="deliveryLeadfiles" name="deliveryLeadfiles" class="form-control"  onChange={this.handleChangeFileDeliverLead}
                                                /> */}
                    </div>

                    <span id="filediv" style={{ marginTop: "-8px" }}>
                      <div id="LeadList"></div>

                      <div style={{ color: "red", paddingTop: "23px" }}>
                        {this.state.errors.fileExt}
                      </div>
                      <div style={{ color: "red" }}>
                        {this.state.fileerrors.fileextensions}
                      </div>

                      <div style={{ color: "red" }}>
                        {this.state.formaterrors.format}
                      </div>

                      {/* Sandeep-task-3499-added code to  display error */}
                      {/* <div className="msg" style={{ color: 'red',marginLeft:"-111px" }} >{this.state.msg}</div> sunita-task-3507 - commented the code from this place and handled as per condition in below */}

                      {/* sunita-task-3507-added code for handling error msgs alignment as per condition */}
                      {this.state.fileerrors.fileextensions ? (
                        ""
                      ) : (
                        <div
                          className="msg"
                          style={{ color: "red", marginLeft: "-111px" }}
                        >
                          {this.state.msg}{" "}
                        </div>
                      )}

                      <div
                        id="pleaseClick"
                        style={{
                          color: "red",
                          fontWeight: "bold",
                          fontSize: "13px",
                          top: "-500px",
                        }}
                      ></div>
                    </span>
                  </div>
                  <div
                    id="voiceLogLink"
                    style={{
                      color: "#056FB9",
                      fontWeight: "bold",
                      fontSize: "20px",
                      display: "none",
                    }}
                  >
                    <a
                      href="#/" //Nilesh-4240-Removing console warnings
                      onClick={this.viewVoiceLogs}
                    >
                      Click here to upload voice logs
                    </a>
                  </div>
                </MDBCol>
                <MDBCol lg="3">
                  <div style={{ color: "red" }}>{this.state.errors.file}</div>
                </MDBCol>
              </MDBRow>
              <MDBRow>
                {/*Priyanka-4611-4635-Displaying error messages of delivery template validations*/}
                <MDBCol lg="12">
                  {this.state.headerErrors.error ? (
                    <span>
                      <div
                        style={{
                          color: "red",
                          paddingTop: "1%",
                          marginLeft: "1%",
                        }}
                      >
                        {this.state.headerErrors.error}
                      </div>
                      {this.state.headerErrors.rejectedHeaders ? (
                        <div
                          style={{
                            color: "red",
                            paddingTop: "0.5%",
                            marginLeft: "1%",
                          }}
                        >
                          <b>{this.state.headerErrors.rejectedHeaders}</b>
                          {this.state.rejectedHeaders.join(", ")}
                        </div>
                      ) : (
                        ""
                      )}
                      {this.state.headerErrors.missingHeaders ? (
                        <div
                          style={{
                            color: "red",
                            paddingTop: "0.5%",
                            marginLeft: "1%",
                          }}
                        >
                          <b>{this.state.headerErrors.missingHeaders}</b>
                          {this.state.missingHeaders.join(", ")}
                        </div>
                      ) : (
                        ""
                      )}
                      {/* Chaitanya-4719-Duplicate headers in delivery template due to CQ alias name */}
                      {this.state.headerErrors.duplicateHeaders ? (
                        <div
                          style={{
                            color: "red",
                            paddingTop: "0.5%",
                            marginLeft: "1%",
                          }}
                        >
                          <b>{this.state.headerErrors.duplicateHeaders}</b>
                          {this.state.duplicateHeaders.join(", ")}
                        </div>
                      ) : (
                        ""
                      )}
                      {/* Rutuja task 5567 if missing asset found then show error with asset name */}
                      {this.state.headerErrors.missingAsset ? (
                        <div
                          style={{
                            color: "red",
                            paddingTop: "0.5%",
                            marginLeft: "1%",
                          }}
                        >
                          <b>{this.state.headerErrors.missingAsset}</b>
                        </div>
                      ) : (
                        ""
                      )}
                    </span>
                  ) : (
                    ""
                  )}
                </MDBCol>
              </MDBRow>

              <br />

              <div style={{ display: this.state.tableDisplay }}>
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-8 col-lg-9">
                    {result.map((result) => {
                      if (result.totalLead != undefined) {
                        return (
                          <label
                            class="font-weight-bold"
                            style={{
                              color: "green",
                              fontSize: "13px",
                              marginLeft: "10px",
                            }}
                          >
                            Leads are uploaded successfully!&nbsp;
                          </label>
                        );
                      }
                    })}

                    {result.map((result) => {
                      if (result.totalLead != undefined) {
                        return (
                          <label
                            class="font-weight-bold"
                            style={{
                              color: "black",
                              fontSize: "13px",
                              marginLeft: "10px",
                            }}
                          >
                            ( Total:&nbsp;
                            <span
                              style={{ color: "black", fontWeight: "bold" }}
                            >
                              {result.totalLead}
                            </span>
                            <span style={{ color: "black" }}>
                              &nbsp;|&nbsp;
                            </span>
                          </label>
                        );
                      }
                    })}

                    {result.map((result) => {
                      if (result.acceptedLead != undefined) {
                        return (
                          <label
                            class="font-weight-bold"
                            style={{ fontSize: "13px", color: "green" }}
                          >
                            &nbsp; Internal Review:&nbsp;
                            <span
                              style={{ color: "green", fontWeight: "bold" }}
                            >
                              {result.acceptedLead}
                            </span>
                            <span
                              style={{ color: "black", fontWeight: "bold" }}
                            >
                              <span style={{ color: "black" }}>
                                &nbsp;&nbsp;|&nbsp;
                              </span>
                            </span>
                          </label>
                        );
                      }
                    })}

                    {/*Akash-Bug-4238*/}

                    {this.state.rejectlead > 0 ? (
                      <label
                        class="font-weight-bold"
                        style={{ fontSize: "13px", color: "red" }}
                      >
                        &nbsp; Rejected:&nbsp;
                        <span style={{ color: "red", fontWeight: "bold" }}>
                          {this.state.rejectlead}
                        </span>
                        <span style={{ color: "black", fontWeight: "bold" }}>
                          &nbsp;&nbsp;|&nbsp;
                        </span>
                      </label>
                    ) : (
                      ""
                    )}
                    {result.map((result) => {
                      if (result.voiceLogLead != undefined) {
                        return (
                          <label
                            class="font-weight-bold"
                            style={{
                              color: "rgb(5, 110, 184",
                              fontSize: "13px",
                            }}
                          >
                            &nbsp; VoiceLogPending:&nbsp;
                            <span
                              style={{
                                color: "rgb(5, 110, 184",
                                fontWeight: "bold",
                              }}
                            >
                              {result.voiceLogLead}
                            </span>
                            <span
                              style={{ color: "black", fontWeight: "bold" }}
                            ></span>
                            <span style={{ color: "black" }}>&nbsp;)</span>
                          </label>
                        );
                      }
                    })}
                  </div>
                  {/*Akash-Bug-4238*/}
                  {result.map((result) => {
                    if (result.totalLead != undefined) {
                      return (
                        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3">
                          <span>
                            <a
                              href="#/" //Nilesh-4240-Removing console warnings
                            >
                              <img
                                alt="" //Nilesh-4240-Removing console warnings
                                src="download1.png"
                                onClick={this.downloadAuditReport}
                                id={this.state.campID}
                                style={{
                                  width: "18px",
                                  height: "18px",
                                  color: "#17278E",
                                  float: "right",
                                  marginRight: "10px",
                                }}
                              ></img>
                            </a>
                            <span
                              id=""
                              style={{
                                color: "#40a9ff",
                                fontWeight: "500",
                                float: "right",
                                marginRight: "15px",
                                fontSize: "14px",
                              }}
                            >
                              Download Audit Report
                            </span>
                          </span>
                          &nbsp;&nbsp;
                        </div>
                      );
                    }
                  })}
                </div>

                <MDBRow>
                  <MDBCol lg="12" className="mb-12">
                    <div style={{ paddingTop: "10px" }}>
                      <div style={{ width: "100%" }}>
                        {result.map((result) => {
                          if (result.totalLead != undefined) {
                            return (
                              <div
                                class="row"
                                id="topdiv"
                                style={{
                                  width: "99.5%",
                                  marginLeft: "3px",
                                  backgroundColor: "white",
                                }}
                              >
                                {/* Nilesh-4726- showing continue button and error massege */}
                                {this.state.statusResults.length > 0 ? (
                                  <div class="col-xs-11 col-sm-11 col-md-6 col-lg-9 to1">
                                    <Checkbox
                                      style={{
                                        fontSize: 15,
                                        textAlign: "left",
                                        marginBottom: "-60px",
                                        marginTop: "5px",
                                      }}
                                      checked={this.state.domainChecked}
                                      onChange={this.onChangeDoaminCheckbox}
                                    >
                                      <span style={{ color: "red" }}>
                                        Click on 'Continue' button to disable
                                        Email Domain Validation for those leads
                                        showing error 'REJECT_EMAIL_INVALID
                                        DOMAIN'.
                                      </span>
                                    </Checkbox>
                                    <div class="col-xs-11 col-sm-11 col-md-6 col-lg-2">
                                      <button
                                        type="submit"
                                        // data-dismiss="modal"
                                        className={this.state.btnDisable}
                                        disabled={
                                          this.state.isDomainCheckedboxVisible
                                            ? this.state.domainChecked
                                              ? false
                                              : true
                                            : false
                                        }
                                        style={{
                                          backgroundColor: "#0000b3",
                                          color: "white",
                                          borderRadius: "3px",
                                        }}
                                        onClick={this.offDomainValidation}
                                      >
                                        <b>Continue...</b>
                                      </button>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                <div class="col-xs-11 col-sm-11 col-md-6  offset-lg-2 col-lg-7 to1">
                                  <span
                                    id="statusDiv"
                                    style={{
                                      color: "black",
                                      float: "right",
                                      marginTop: "15px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    Status:&nbsp;&nbsp;&nbsp;&nbsp;
                                    <select
                                      id="selfil"
                                      style={{
                                        height: "29px",
                                        width: "280px",
                                        backgroundColor: "#F5F5F5",
                                        border: "1px solid #DCDCDC",
                                      }}
                                      value={this.state.selectedLead}
                                      required
                                      onChange={this.selectLead}
                                    >
                                      <option
                                        value="All"
                                        selected
                                        style={{ fontWeight: "bold" }}
                                      >
                                        All
                                      </option>
                                      {this.state.leadfilter.map(
                                        (leadfilter) => {
                                          return (
                                            <option
                                              value={leadfilter.label}
                                              style={{ fontWeight: "bold" }}
                                            >
                                              {leadfilter.label}
                                            </option>
                                          );
                                        }
                                      )}
                                    </select>
                                  </span>
                                </div>
                                <div
                                  class="col-xs-11 col-sm-11 offset-md-6 col-md-6 offset-lg-9 col-lg-3 "
                                  id="searchAdj"
                                  style={{
                                    height: "50px",
                                    marginTop: "-30px",
                                    marginRight: "20px",
                                  }}
                                >
                                  <span style={{ marginTop: "15px" }}>
                                    <input
                                      className="search"
                                      id="searchAdj1"
                                      type="text"
                                      name="search"
                                      placeholder="Search"
                                      style={{
                                        backgroundImage: "url(searchIcon.png)",
                                        backgroundPosition: "15px 6px",
                                        backgroundSize: "15px 15px",
                                        backgroundRepeat: "no-repeat",
                                        width: "215px",
                                        height: "30px",
                                        fontSize: "10px",
                                        border: "1px solid lightGray",
                                        padding: "12px 20px 12px 34px",
                                      }}
                                      onChange={this.handleChangeSearch}
                                      onPressEnter={this.handleChangeSearch}
                                    ></input>
                                  </span>
                                </div>
                              </div>
                            );
                          }
                        })}

                     {/* Nilesh-5742-full-page blocking */}
                      {this.state.loaderLead === 'loader_uploadLead' && (
                        <>
                          <div align="center" id="overlay_uploadLead"></div>
                          <div align="center" id="loader_uploadLead"></div>
                        </>
                      )}

                        <Table
                          {...this.state.tableState}
                          //id="myTable"
                          bordered
                          dataSource={
                            this.state.tableSearchText === "" //Nilesh-4240-Removing console warnings
                              ? this.state.leadDetailsData
                              : this.state.columnSearch
                          }
                          columns={column1}
                          className={tableCSS}
                          //locale={this.state.loading1?locale:"No Data"}//Sandeep task-3341
                          size="small"
                          scroll={{ y: 2000, x: 500 }}
                          pagination={{ pageSize: this.state.pageSize1 }}
                        ></Table>
                        {/* kiran-4514-4446-adjusted scroll size for responsiveness */}
                        {this.state.loading1 === false ? (
                          <div
                            class="col-xs-12 col-sm-12 col-md-5 col-lg-6 col-xl-6"
                            style={{ marginTop: "-53px" }}
                          >
                            Records per page:&nbsp;
                            <select
                              defaultValue={this.state.pageSize1}
                              onChange={this.handleChangePageSize1}
                              id="pacing11"
                              class="input-small"
                              className="form-control"
                              name="pacing"
                              style={{
                                width: "80px",
                                height: "30px",
                                display: "initial",
                              }}
                            >
                              <option value="100" selected>
                                100
                              </option>
                              <option value="500">500</option>
                              <option value="1000">1000</option>
                            </select>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      {/* Sandeep-task-3119-added code to  display error */}
                    </div>
                  </MDBCol>
                </MDBRow>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

/**
 * @author Narendra Phadke
 * @param  Description handle the login authentication
 * @return Description return All details of authentication
 */
PublisherDeliverLead.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});
export default connect(mapStateToProps, { logoutUser })(
  withRouter(PublisherDeliverLead)
);
